import Cookies from "js-cookie";
import {
  ENVIORNMENTS,
  getCurrentEnviornment,
  REACT_APP_baseURL,
  REACT_APP_baseURL_sandbox,
} from "utils/constants";

const routesWithoutHeader = ["/user/dashboardStats", "/simulation_history"];

export async function APIHandlerV2({
  method,
  url,
  data,
  isM2CBackendUrl,
  isSimulationUrl,
}: any) {
  const sandboxOrLiveUrl =
    getCurrentEnviornment() === ENVIORNMENTS.LIVE
      ? process.env.REACT_APP_baseURL
      : process.env.REACT_APP_baseURL_sandbox;

  const myAuth = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);
  const secret_id = localStorage.getItem("secret_id");
  const userEmail = localStorage.getItem("userEmail");
  const combineURL = (url: any) => {
    const baseUrl = getBaseUrl(isM2CBackendUrl, isSimulationUrl);
    return sandboxOrLiveUrl + url;
  };

  function getBaseUrl(isM2CBackendUrl: any, isSimulationUrl: any) {
    if (isM2CBackendUrl) {
      return process.env.REACT_APP_M2C_BACKEND_URL;
    }

    if (isSimulationUrl) {
      return process.env.REACT_APP_SimulationBaseServerURL;
    }

    return process.env.REACT_APP_BaseServerURL;
  }

  const raw = JSON.stringify(data);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `${myAuth}/${secret_id}`);

  // myHeaders.append("Email", `${userEmail}`);

  if (routesWithoutHeader.includes(url)) {
    myHeaders.delete("Email");
    myHeaders.delete("Authorization");
  }

  const requestOptions: any = {
    method: method,
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(combineURL(url), requestOptions);
    const result = await response.text();
    const res = JSON.parse(result);

    if (res === "Logged Out") {
      Cookies.remove("sessionToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("userEmail");
      window.location.replace("/");
    }

    return res; // Return the fetched data
  } catch (error) {
    console.error(error);
    throw error; // Rethrow the error for handling in the calling function
  }
}
